var moment = require('moment');

export {
    deepClone,
    convertToPascalCase,
    convertToCamelCase,
    convertToBase64,
    formatDate,
    getReducedFraction,
    htmlToText,
    genericValidator,
    errorValidator
};

function deepClone(destination, source)
{
    return Object.assign(destination, JSON.parse(JSON.stringify(source)));
}

function convertToPascalCase(string)
{
    return string.replace(/(\w)(\w*)/g,
        function(g0,g1,g2){return g1.toUpperCase() + g2.toLowerCase();});
}

function convertToCamelCase(str) {
    return str.replace(/(?:^\w|[A-Z]|\b\w)/g, function(word, index) {
      return index === 0 ? word.toLowerCase() : word.toUpperCase();
    }).replace(/\s+/g, '');
  }

// function to encode file data to base64 encoded string
function convertToBase64(blob) {
    if(!blob)
    {
        return Promise.resolve(false);
    }
    else
    {
        const reader = new FileReader();
        reader.readAsDataURL(blob);
        return new Promise(resolve => {
            reader.onloadend = () => {
                resolve(reader.result);
            };
        }); 
    }   
}

function formatDate(date)
{
    if(!(date instanceof Date))
    {
        date = new Date(date);
    }

    return moment(date).format('DD/MM/YYYY');
}

function getReducedFraction(numerator, denominator)
{
    var gcd = getCommonDenominator(numerator, denominator);
    return `${numerator/gcd}:${denominator/gcd}`
}

function getCommonDenominator(a,b){
    return b ? getCommonDenominator(b, a%b) : a;
};

function htmlToText(html)
{
    var div = document.createElement('div');
    div.innerHTML = html.trim();
    return div.textContent || div.innerText || "";
}

function genericValidator(val){
    var result = undefined; // This is the default, in case the user hasn't triedSubmit yet

    if(this.triedSubmit)
    {
        if(val instanceof Object) // Multilanguage field (title, description)
        {
            // Validate all fields
            for (const [key, value] of Object.entries(val)) {
                if(!value)
                {
                    result = false;
                    break;
                }
            }
        }
        else if(val instanceof Array) // Array (images)
        {
            result = Boolean(val.length);
        }
        else
        {
            result = Boolean(val);
        }
    }
    return result;
}

function errorValidator(fieldName)
{
    var result = undefined;

    if(this.alertOutput && Array.isArray(this.alertOutput)) // Error alertOutput
    {
        if(this.alertOutput.find(obj => {
            return obj.key === fieldName
        }))
        {
            result = false;
        }
    }

    return result;
}